import { METRIC_CONFIG_REGISTRY } from "@/components/charts/CommonMetricCharts.constants";

export const ONLINE_QUERY_COUNT_BY_NAME_CONFIG = METRIC_CONFIG_REGISTRY.ONLINE_QUERY_COUNT_BY_NAME;

export const ONLINE_QUERY_COUNT_BY_RESOURCE_GROUP_CONFIG =
  METRIC_CONFIG_REGISTRY.ONLINE_QUERY_COUNT_BY_RESOURCE_GROUP;

// Builder that accepts the table's active filters / group-by so the chart query matches it.
export const onlineQueryCountConfig = METRIC_CONFIG_REGISTRY.ONLINE_QUERY_COUNT_FILTERED;

// Mirrors the supported query-name and resource-group dimensions of plan-latency metrics.
export const onlineQueryPlanLatencyConfig =
  METRIC_CONFIG_REGISTRY.ONLINE_QUERY_PLAN_LATENCY_FILTERED;

export const ONLINE_QUERY_COUNT_CHART = METRIC_CONFIG_REGISTRY.ONLINE_QUERY_COUNT_BY_DEPLOYMENT;

export const RESOLVER_COUNT_CHART = METRIC_CONFIG_REGISTRY.RESOLVER_COUNT_BY_NAME;

export const RESOLVER_LATENCY_CHART = METRIC_CONFIG_REGISTRY.RESOLVER_LATENCY_P95_BY_NAME;

export const NO_RESOLVER_COUNT_ENVS = new Set<string>([
  "whtnt75hcuxbbg",
  "whtntjcyeszzdd",
  "whtntd3xutt8gy",
]);
